import styled from 'styled-components';

export const Box = styled.div`
padding: 80px 250px;

position: absolute;
bottom: 0;
width: 100%;


@media (max-width: 1200px) {
    padding: 0px 0px;
	width: 10%;
  }

`
export const Containers = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	max-width: 1000px;
	margin:  auto;
	/* background: red; */
`

export const Columns = styled.div`
display: flex;
flex-direction: column;
text-align: left;
margin-left: 60px;
`;

export const Rows = styled.div`
display: fixed;
grid-template-columns: repeat(auto-fill,
						minmax(200px, 1fr));
grid-gap: 20px;


@media (max-width: 10000px) {
	grid-template-columns: repeat(auto-fill,
						minmax(200px, 1fr));
}
`;

export const FooterLinks = styled.a`
color: #fff;
margin-bottom: 20px;
font-size: 18px;
text-decoration: none;

&:hover {
	color: green;
	transition: 200ms ease-in;
}
`;

export const Headings = styled.p`
font-size: 24px;
color: #fff;
margin-bottom: 40px;
font-weight: bold;
`;

